module.exports = __webpack_public_path__ + "static/img/4.1b2aa18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/4.png
// module id = 7pqd
// module chunks = 0